import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import { SiteVisitListTable } from './components/SiteVisitListTable';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { CirclePlus } from 'lucide-react';
import HeaderBanner from '../../../common/HeaderBanner';
import { getLoggedUser } from '../../../../state/user';
import { AddSiteVisitProject } from './components/AddSiteVisitProject';
import { getSiteVisitProjects } from './services/siteVisitProjectService';

export class SiteVisitList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        status: '',
      },
      input: {},
      siteVisits: [],
      is_loading: false,
      limit: 15,
      page: 1,
      rejectNote: null,
      rejectNoteError: null,
      hideSidebar: false,
      showModal: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const params = new URLSearchParams(window.location.search);
    const siteVisitStatus = params.get('siteVisitStatus') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ siteVisitStatus, page, limit }, () => {
      this.getSiteVisits();
    });
  }

  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }

  async getSiteVisits() {
    this.setState({ is_loading: true });
    let { limit, page, siteVisitStatus } = this.state;

    const q = {
      page: page,
      per_page: limit,
      status: siteVisitStatus,
    };

    this.updateUrlQuery(q);

    let response = await getSiteVisitProjects(q);

    if (response.success) {
      let siteVisits = response.data.projects || response.data;
      let pagination = response.data.pagination || response.meta;

      this.setState({
        siteVisits,
        total: pagination?.total || 0,
        is_loading: false,
      });
    } else {
      console.error('Failed to fetch site visits:', response);
      this.setState({
        siteVisits: [],
        is_loading: false,
      });
    }
  }

  handleTabChange = (key) => {
    this.setState({ siteVisitStatus: key }, () => {
      this.getSiteVisits();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getSiteVisits();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getSiteVisits();
    });
  };

  addProject = () => {
    this.setState({ showModal: true });
  };

  render() {
    const user = getLoggedUser();

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('site_visit_projects')}
          subtitle={i18n.t('manage_site_visit_projects')}
        />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>

                    <div>
                      <button onClick={() => this.addProject()} className="no-data-button">
                        {' '}
                        <CirclePlus size={16} /> {i18n.t('Add Project')}
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="Data-Listing">
                      {this.state.is_loading ? (
                        <TableSkeleton columns={8} rows={10} />
                      ) : this.state.siteVisits.length ? (
                        <SiteVisitListTable
                          siteVisits={this.state.siteVisits}
                          isLoading={this.state.is_loading}
                          currentPage={this.state.page}
                          limit={this.state.limit}
                          total={this.state.total}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                          userRole={user?.role}
                        />
                      ) : (
                        <NoData
                          message="No site visits available"
                          actionText={i18n.t('refresh')}
                          onAction={this.getSiteVisits.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AddSiteVisitProject
          show={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          user={user}
          onPaymentComplete={() => {
            this.setState({ showModal: false });
            this.getSiteVisits();
          }}
        />
      </React.Fragment>
    );
  }
}
